import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Products.css';
import { productCatalog } from './instrumentDetails';

const Products = () => {
  const [isVisible, setIsVisible] = useState(false);

  const instrumentTypes = [
    {
      id: 'general',
      name: 'General Surgical Forceps',
      description: 'Comprehensive selection including Adson, Debakey, Kelly, Mosquito, Kocher, Allis, Babcock, and more',
      image: '/images/adson forceps.jpg',
      count: `${productCatalog.general.length} Products`
    },
    {
      id: 'dental',
      name: 'Dental Forceps',
      description: 'Upper/Lower Molar, Premolar, Incisor & Canine, Root, Cowhorn, Bayonet forceps',
      image: '/images/Upper Molar Extracting Forceps.jpg',
      count: `${productCatalog.dental.length} Products`
    },
    {
      id: 'ophthalmic',
      name: 'Ophthalmic (Eye) Forceps',
      description: 'Iris, Corneal, Lens, Capsulorhexis, Fixation, Bishop-Harmon, McPherson, Bonn',
      image: '/images/Iris Forceps.jpg',
      count: `${productCatalog.ophthalmic.length} Products`
    },
    {
      id: 'gynecology_obstetric',
      name: 'Gynecology / Obstetric Forceps',
      description: 'Uterine, Sponge Holding, Foerster, Vulsellum, Ovum, Kocher’s Obstetric Forceps',
      image: '/images/Uterine Dressing Forceps.jpg',
      count: `${productCatalog.gynecology_obstetric.length} Products`
    },
    {
      id: 'specialty',
      name: 'Orthopedic / ENT / Specialty Forceps',
      description: 'Bone Holding/Cutting, Tilley Nasal, Hartmann Alligator, Ear Dressing, Biopsy, Cushing, Russian Tissue',
      image: '/images/Bone Holding Forceps.jpg',
      count: `${productCatalog.specialty.length} Products`
    }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.05 }
    );

    const element = document.getElementById('products');
    if (element) {
      observer.observe(element);
    } else {
      // Fallback: set visible after a short delay if element not found
      setTimeout(() => setIsVisible(true), 100);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, []);

  return (
    <section id="products" className="products section">
      <div className="container">
        <div className={`section-header ${isVisible ? 'animate-in' : ''}`}>
          <h2 className="section-title">Product Categories</h2>
          <p className="section-description">
            Explore our comprehensive range of forceps across general, dental, ophthalmic, gynecology/obstetric, and specialty
          </p>
        </div>

        <div className={`products-grid ${isVisible ? 'animate-in' : ''}`}>
          {instrumentTypes.map((type, index) => (
            <div 
              key={type.id} 
              className={`product-card category-card modern-card ${isVisible ? 'animate-in' : ''}`}
              data-category={type.id}
              style={{ animationDelay: `${index * 0.1}s`, '--index': index }}
            >
              <div className="product-image">
                <img 
                  src={type.image} 
                  alt={type.name}
                  onError={(e) => {
                    e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjMwMCIgdmlld0JveD0iMCAwIDMwMCAzMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIzMDAiIGhlaWdodD0iMzAwIiBmaWxsPSIjRjNGNEY2Ii8+CjxwYXRoIGQ9Ik0xNTAgMTAwQzEyMi4zODYgMTAwIDEwMCAxMjIuMzg2IDEwMCAxNTBDMTAwIDE3Ny42MTQgMTIyLjM4NiAyMDAgMTUwIDIwMEMxNzcuNjE0IDIwMCAyMDAgMTc3LjYxNCAyMDAgMTUwQzIwMCAxMjIuMzg2IDE3Ny42MTQgMTAwIDE1MCAxMDBaIiBmaWxsPSIjRDFENUQ5Ii8+CjxwYXRoIGQ9Ik0xMzUgMTM1SDE2NVYxNjVIMTM1VjEzNVoiIGZpbGw9IiM5Q0EzQUYiLz4KPC9zdmc+';
                  }}
                />
              </div>
              <div className="product-info">
                <h3 className="product-name">{type.name}</h3>
                <p className="product-count">{type.count}</p>
                <p className="product-description">{type.description}</p>
                <div className="product-actions">
                  <Link to={`/products?category=${type.id}`} className="btn btn-primary btn-sm">
                    Explore Category
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;